module.exports = "::ng-deep .gm-svpc{display:none}agm-map{max-height:90vh}"